export const GET_TRANSLATION_AND_EXAMPLES = 'GET_TRANSLATION_AND_EXAMPLES'
export const GET_TRANSLATION_AND_EXAMPLES_ERROR =
  'GET_TRANSLATION_AND_EXAMPLES_ERROR'
export const LOADING_TRANSLATION = 'LOADING_TRANSLATION'
export const LOADING_API = 'LOADING_API'
